import React, { Component } from "react";

class SimplePagination extends Component {
  constructor(props) {
    super(props);
    const { currentPage, totalFiles, split } = this.props;
    const totalPages = Math.ceil(totalFiles / split);
    this.state = {
      visiblePages: this.getVisiblePages(currentPage, totalPages),
    };
  }

  componentDidUpdate(prevProps) {
    const { currentPage, totalFiles, split } = this.props;
    const totalPages = Math.ceil(totalFiles / split);
    const prevTotalPages = Math.ceil(prevProps.totalFiles / prevProps.split);

    if (currentPage !== prevProps.currentPage || totalPages !== prevTotalPages) {
      this.setState({ visiblePages: this.getVisiblePages(currentPage, totalPages) });
    }
  }

  getVisiblePages(page, total) {
    if (total <= 5) {
      return Array.from({ length: total }, (_, i) => i + 1);
    }
    if (page <= 3) {
      return [1, 2, 3, 4, 5];
    }
    if (page >= total - 2) {
      return [total - 4, total - 3, total - 2, total - 1, total];
    }
    return [page - 2, page - 1, page, page + 1, page + 2];
  }

  handlePageSwitch = (page) => {
    const { totalFiles, split, updateCurrentPage } = this.props;
    const totalPages = Math.ceil(totalFiles / split);
    if (page > 0 && page <= totalPages) {
      updateCurrentPage(page);
      this.setState({ visiblePages: this.getVisiblePages(page, totalPages) });
    }
  };

  render() {
    const { currentPage, totalFiles, split } = this.props;
    const totalPages = Math.ceil(totalFiles / split);
    const { visiblePages } = this.state;

    return (
      <div className="d-flex justify-content-center align-items-center flex-wrap">
        <div className="d-flex flex-wrap py-2 mr-3">
          <a
            onClick={() => this.handlePageSwitch(currentPage - 1)}
            className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
            style={{ cursor: "pointer" }}
          >
            <i className="ki ki-bold-arrow-back icon-xs"></i>
          </a>
          {visiblePages.map((page) => (
            <a
              key={page}
              onClick={() => this.handlePageSwitch(page)}
              className={`btn btn-icon btn-sm border-0 btn-hover-primary mr-2 my-1 ${page === currentPage ? 'active' : ''}`}
              style={{ cursor: 'pointer' }}
            >
              {page}
            </a>
          ))}
          {totalPages > 5 && currentPage < totalPages - 2 && (
            <a
              onClick={() => this.handlePageSwitch(currentPage + 3)}
              className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
              style={{ cursor: "pointer" }}
            >
              Más
            </a>
          )}
          <a
            onClick={() => this.handlePageSwitch(currentPage + 1)}
            className="btn btn-icon btn-sm btn-light-primary mr-2 my-1"
            style={{ cursor: "pointer" }}
          >
            <i className="ki ki-bold-arrow-next icon-xs"></i>
          </a>
        </div>
      </div>
    );
  }
}

export default SimplePagination;
